import * as types from '../mutation-types'
import { api } from '@/modules/api'
import preparePayload from '@/utils/preparePayload'

const state = {
  companies: [],
  totalCompaniesPages: 0,
  totalItems: 0
}

const getters = {
  getCompanies: state => state.companies,
  getTotalApprovedCompaniesPages: state => state.totalCompaniesPages,
  getTotalApprovedCompanies: state => state.totalItems
}

const actions = {
  async fetchCompaniesList ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.companies.getCompaniesList(payload))
      commit(types.SET_COMPANIES_LIST, data)
      return data
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to load companies list')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateCompanies ({ commit }, updatedCompanies) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const payload = {
        blitzes: updatedCompanies.reduce((acc, company) => {
          console.log('company is sponsor: ', company.isSponsor)
          acc.push({
            id: company.id,
            body: company.body,
            order: company.order,
            status: company.status,
            isSponsor: company.isSponsor
          })
          return acc
        }, [])
      }
      await this.$axios.put(api.companies.update(), preparePayload.filterNullAndDeleteEmptyObjects(payload))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, err.response.data.Message)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_COMPANIES_LIST] (state, { blitzes, totalPages, totalItems }) {
    state.companies = [...blitzes]
    state.totalCompaniesPages = totalPages
    state.totalItems = totalItems
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/display.js